var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:(_vm.matches && _vm.matches.length > 0 && _vm.classes(_vm.matches[0].context, 'match')) ||
      (_vm.evidences &&
        _vm.evidences.length > 0 && {
          evidence: true,
          'evidence-highlighted': _vm.evidences
            .map(function (evidence) { return evidence.id; })
            .includes(_vm.id)
        })},[_c('span',{class:(_vm.matches &&
        _vm.matches.length > 0 &&
        _vm.classes(_vm.matches[0].context, 'match')) ||
        (_vm.evidences &&
          _vm.evidences.length > 0 && {
            evidence: true,
            'evidence-highlighted': _vm.evidences
              .map(function (evidence) { return evidence.id; })
              .includes(_vm.id)
          }),domProps:{"innerHTML":_vm._s(_vm.value.text.replace(/\n/g, '<br>'))}}),_vm._v(_vm._s(_vm.value.delimiter))])}
var staticRenderFns = []

export { render, staticRenderFns }